import React, { useState } from "react";
import { useDrop } from "react-dnd";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useForm } from "react-hook-form";
import SidebarItem from "./SidebarItem";
import FormField from "./FormField";
import './index.css';

const FIELD_TYPES = {
  TEXT: "text",
  DROPDOWN: "dropdown",
  DATE: "date",
};

const FormBuilder = () => {
  const [fields, setFields] = useState([]);
  const { handleSubmit } = useForm();

  const [{ isOver }, drop] = useDrop({
    accept: "field",
    drop: (item) => addField(item),
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  });

  const addField = (item) => {
    setFields((prev) => [...prev, item]);
  };

  const moveField = (fromIndex, toIndex) => {
    setFields((prev) => {
      const updatedFields = [...prev];
      const [movedItem] = updatedFields.splice(fromIndex, 1);
      updatedFields.splice(toIndex, 0, movedItem);
      return updatedFields;
    });
  };
  
  const removeField = (index) => {
    setFields((prev) => prev.filter((_, i) => i !== index));
  };

  const onSubmit = (data) => {
    console.log("Form Data:", data);
  };

  return (
    <div className="container">
      {/* Sidebar */}
      <div className="sidebar">
        <h3>Form Fields</h3>
        <SidebarItem type={FIELD_TYPES.TEXT} label="Text Field" />
        <SidebarItem type={FIELD_TYPES.DROPDOWN} label="Dropdown Field" />
        <SidebarItem type={FIELD_TYPES.DATE} label="Date Field" />
      </div>

      {/* Drop Area */}
      <div ref={drop} className={`form-builder ${isOver ? "highlight" : ""}`}>
        <h3>Drag Fields Here</h3>
        <form onSubmit={handleSubmit(onSubmit)}>
          {fields.length === 0 && <p className="placeholder">Drop fields here to build your form</p>}
          {fields.map((field, index) => (
            <FormField key={index} field={field} index={index} moveField={moveField} removeField={removeField} />
          ))}
          {fields.length > 0 && <button type="submit">Submit</button>}
        </form>
      </div>
    </div>
  );
};

export default FormBuilder;
